import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { TableSummaryBarItemModel, TableSummaryBarItemTypeEnum } from '../table-summary-bar.model';
import { selectCompanyTimezoneOffset } from 'projects/workspace/src/app/administration/store/selectors';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';


@Component({
  selector: 'rnpl-table-summary-bar-item',
  templateUrl: './table-summary-bar-item.component.html',
  styleUrls: ['./table-summary-bar-item.component.scss']
})
export class TableSummaryBarItemComponent {

  @Input() summaryBarItem: TableSummaryBarItemModel;

  @Output() itemClick = new EventEmitter<TableSummaryBarItemModel>();

  public ITEM_TYPES = TableSummaryBarItemTypeEnum;

  readonly companyProfileTimezoneOffset$: Observable<string> = this.store.select(selectCompanyTimezoneOffset);

  constructor(
    private readonly store: Store<AppState>,
  ) { }

  public onClick(): void {
    if (this.summaryBarItem.clickable) {
      this.itemClick.emit(this.summaryBarItem);
    }
  }

}
